export default __webpack_public_path__ + "static/portfolio-12-db1dd4bd4c7ca3174c7609fb85b8eb18.jpg";